export class StepGuideV2SetupHelp {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "guide_v2_setup_help";
  title = "Help";

  template = `
  <div class="onboarding-step" data-for="guide_v2_setup_help">
    
    <div class="onboarding-guide">
    
      <h2 class="onboarding-guide-heading">
        Steps to reset your Temp Stick:
      </h2>
      <p class="onboarding-guide-instruction">
        While the device is powered on, hold down the reset button until the red light on the front turns on, then release.
      </p>
      
      <img data-for="v2-reset-button" class="onboarding-guide-instruction-image" src="${window.site.home}/../assets/images/setup/temp-stick-v2-help-reset.png" width="500" height="513" />
      
      <p class="onboarding-guide-instruction">
        Click when the red light is blinking steady.
      </p>
      
      <div class="onboarding-guide-next">
        <button class="button onboarding-guide-next-btn" data-for="guide_v2_setup_help_next">
          The Light Is Blinking Red
        </button>
      </div>
      
      <h2 class="onboarding-guide-heading" style="text-align: center;">
        Still Not Blinking Red?
      </h2>
      
      <p class="onboarding-guide-instruction">
        Please contact our friendly support team for assistance at 888.263.6973.      
      </p>
      
    </div>
   
    
  </div>
  `;

  onBack = () => {
    this.onboarding.goToStep("guide_v2_setup_mode");
    this.onboarding.hideBackButton();
  }

  onActivate = () => {
    this.onboarding.showBackButton();
  }

  bindActions = () => {

    this.$nextBtn = $(this.onboarding.container).find('button[data-for="guide_v2_setup_help_next"]');
    this.$nextBtn.on('click', () => {
      this.onboarding.goToConnection();
    });

  }

}
